<template>
  <div>
    <Head title="ItemLocations" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      ItemLocations
    </h1>
    <div class="flex items-center justify-between mb-6 md:w-1/2">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset">
        <label class="block text-gray-700">Location:</label>
        <select v-model="form.location" class="form-select mt-1 w-full">
          <option :value="null" />
          <option
            v-for="areaproject in areaprojects"
            :key="areaproject.id"
            :value="areaproject.id">
            {{ areaproject.location }}
          </option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/itemlocations/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;ItemLocation</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto md:w-1/2">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Area Project
            </th>
            <th class="pb-4 pt-6 px-6">
              Name
            </th>
            <th class="pb-4 pt-6 px-6" colspan="2">
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="itemlocation in itemlocations.data"
            :key="itemlocation.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/itemlocations/${itemlocation.id}/edit`">
                {{ itemlocation.location }}
                <icon
                  v-if="itemlocation.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/itemlocations/${itemlocation.id}/edit`"
                tabindex="-1">
                {{ itemlocation.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/itemlocations/${itemlocation.id}/edit`"
                tabindex="-1">
                {{ itemlocation.desc }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/itemlocations/${itemlocation.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="itemlocations.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">
              No itemlocations found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="itemlocations.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        itemlocations: Object,
        areaprojects: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                location: this.filters.location,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/itemlocations', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
